module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ca81e298812f54aa66da9e641b34058d.png";